import React from 'react';
import PropTypes from 'prop-types';

/**
 * A simple separator component that renders a dash between filter range elements
 *
 * @param {Object} props - Component props
 * @param {string} props.className - CSS class name for styling
 * @returns {React.ReactElement} A span element with a dash character
 */
const Separator = ({ className }) => (
  <span aria-hidden="true" className={className}>
    —
  </span>
);

Separator.propTypes = {
  className: PropTypes.string.isRequired,
};

export default Separator;
